// #region const BUTTON_XXX
export const BUTTON_STATE = {
  DEFAULT: 'DEFAULT',
  HOVER: 'HOVER',
  SELECTED: 'SELECTED',
  DISABLED: 'DISABLED'
};
export const BUTTON_THEME = {
  TOSCA: 'tosca',
  TEAL: 'teal',
  BLACK: 'black',
  GREY: 'grey',
  RED: 'red'
};
export const BUTTON_SIZE = {
  SMALL: 'SMALL',
  NORMAL: 'NORMAL'
};
export const BUTTON_TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
};
// #endregion

const buttonInfo = {
  BUTTON_STATE,
  BUTTON_SIZE,
  BUTTON_TYPE,
  BUTTON_THEME
};
export default buttonInfo;